import { ReactNode, Ref } from 'react';

import AppNotifications from 'src/components/app-notifications';

import './elementary-school-assignments-wrapper.scss';

type Props = {
  children: ReactNode;
  wrapperRef: Ref<HTMLDivElement>;
};

export const ElementarySchoolAssignmentsWrapper = ({
  children,
  wrapperRef,
}: Props) => {
  return (
    <>
      <AppNotifications />
      <div className="elementary-school-assignments-wrapper" ref={wrapperRef}>
        {children}
      </div>
    </>
  );
};
